import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'var(--bg-primary)' }}>
          <div className="text-center">
            <h1 className="font-['Bebas_Neue'] text-4xl tracking-wide mb-4" style={{ color: 'var(--text-primary)' }}>
              SOMETHING WENT WRONG
            </h1>
            <p className="font-['Lato'] text-sm mb-8" style={{ color: 'var(--accent-text-medium)' }}>
              An unexpected error occurred. Please try again.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.href = '/';
              }}
              className="inline-flex items-center gap-2 font-['Lato'] text-xs font-bold tracking-[0.2em] px-8 py-4 transition-colors hover:opacity-90"
              style={{ background: 'var(--accent)', color: 'var(--text-on-accent)' }}
            >
              BACK TO HOME
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
